import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { ResourceType as t } from "./enums.js";

var e = /*#__PURE__*/function () {
  function e(_e, n) {
    _classCallCheck(this, e);

    this._context = _e, this._desc = n, this._context.instanceCounter.increment(t.Renderbuffer, this);
    var r = this._context.gl;
    this.glName = r.createRenderbuffer(), this._context.bindRenderbuffer(this), r.renderbufferStorage(r.RENDERBUFFER, n.internalFormat, n.width, n.height);
  }

  _createClass(e, [{
    key: "descriptor",
    get: function get() {
      return this._desc;
    }
  }, {
    key: "resize",
    value: function resize(t, _e2) {
      var n = this._desc;
      if (n.width === t && n.height === _e2) return;
      n.width = t, n.height = _e2;
      var r = this._context.gl;
      this._context.bindRenderbuffer(this), r.renderbufferStorage(r.RENDERBUFFER, n.internalFormat, n.width, n.height);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._context && (this._context.gl.deleteRenderbuffer(this.glName), this._context.instanceCounter.decrement(t.Renderbuffer, this), this._context = null);
    }
  }]);

  return e;
}();

export { e as default };